// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer-root-c92fa28a48db4539ff822d3b1f0bffc8"};